class BaBUpsellModal extends HTMLElement {
  constructor() {
    super();

    // Product list
    this.productList = this.querySelector(".bab-upsell-modal--product-list");
    // Individual products
    this.productItems = this.querySelectorAll(
      ".bab-upsell-modal--product-option"
    );
    // Upsell size buttons for each product
    this.productUpdate = this.querySelectorAll(
      ".bab-upsell-modal--option-value"
    );
    // Continue without upsell button
    this.upsellContinue = this.querySelector(".bab-upsell-modal--button");

    this.productUpdate.forEach((button) => {
      //   Trigger a size update
      button.addEventListener("click", () => {
        this.updateSelectedProduct(button);
      });
    });

    this.upsellContinue.addEventListener("click", () => {
      this.closeModal();
      // Trigger a click on the add to cart button to add bundle without upsell
      const addToCartBtn = document.querySelector(".button--add-to-cart");
      if (addToCartBtn) {
        addToCartBtn.click();
      }
    });

    // Close modal on esc button click
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.classList.contains("open")) {
        this.closeModal();
      }
    });

    this.hideOptions();
    this.updatePricing();
  }

  //Open BaBUpsellModal and set focus trap
  openModal(spacesLeft, totalQuantity, focusTarget) {
    const variantSelector = document.querySelector(
      ".bob__summary variant-selects select"
    );
    let selectedOption = null;
    let selectedSize = null;
    let limit = null;

    // Prevent opening if already at highest box size as there's nothing to upsell
    if (variantSelector) {
      let maxSize = -Infinity;
      Array.from(variantSelector.options).forEach((opt) => {
        const size = Number(opt.getAttribute("data-option-size"));
        if (!isNaN(size) && size > maxSize) maxSize = size;
      });
      selectedOption = variantSelector.options[variantSelector.selectedIndex];
      selectedSize = selectedOption
        ? Number(selectedOption.getAttribute("data-option-size"))
        : null;
      limit = selectedSize;
      if (selectedSize !== null && selectedSize === maxSize) {
        return;
      }
    }

    // Prevent opening if box is not full
    if (typeof spacesLeft !== "undefined" && spacesLeft !== 0) {
      return;
    }

    // Prevent opening if totalQuantity does not match selectedSize, this ensures it doesn't sell when all data hasn't fully updated yet
    // Such as downgrading from a 24 to a 12 box, where totalQuantity may still be 24 for a short time and therefore spacesLeft is 0
    if (selectedSize !== null && totalQuantity !== selectedSize) {
      return;
    }

    // Otherwise, open the modal as normal
    this.classList.add("opening");
    this._focusTrapCleanup = null;
    this._focusTrapReturnTarget = focusTarget || null;

    setTimeout(() => {
      this.classList.remove("opening");
      this.classList.add("open");
      // Update z-index of aside.sidebar.bob__summary to 3
      const sidebar = document.querySelector("aside.sidebar.bob__summary");
      if (sidebar) {
        sidebar.style.zIndex = "3";
      }
      //   update aria-hidden
      this.setAttribute("aria-hidden", "false");
      document.body.classList.add("overflow-hidden");

      // Focus trap
      const trapContainer =
        this.querySelector(".bab-upsell-modal--content") || this;
      // Selectors for all focusable elements
      const focusableSelectors = [
        "a[href]",
        "button:not([disabled])",
        "textarea:not([disabled])",
        'input[type="text"]:not([disabled])',
        'input[type="radio"]:not([disabled])',
        'input[type="checkbox"]:not([disabled])',
        "select:not([disabled])",
        '[tabindex]:not([tabindex="-1"])',
      ];
      const focusableEls = trapContainer.querySelectorAll(
        focusableSelectors.join(",")
      );
      const firstFocusableEl = focusableEls[0];
      const lastFocusableEl = focusableEls[focusableEls.length - 1];

      // Move focus to the first visible focusable element, or fallback to modal container
      if (firstFocusableEl) {
        if (
          typeof firstFocusableEl.tabIndex !== "undefined" &&
          firstFocusableEl.tabIndex < 0
        ) {
          firstFocusableEl.tabIndex = -1;
        }
        // If the element is not visible, fallback to modal container
        if (
          firstFocusableEl.offsetParent === null ||
          getComputedStyle(firstFocusableEl).visibility === "hidden" ||
          getComputedStyle(firstFocusableEl).display === "none"
        ) {
          trapContainer.setAttribute("tabindex", "-1");
          trapContainer.focus();
        } else {
          // Focus the first visible focusable element
          firstFocusableEl.focus();
          setTimeout(() => {
            if (document.activeElement !== firstFocusableEl) {
              firstFocusableEl.focus();
            }
          }, 0);
        }
      } else {
        // No focusable element found, focus modal container
        trapContainer.setAttribute("tabindex", "-1");
        trapContainer.focus();
      }

      function trapFocus(e) {
        // Trap focus within the modal
        if (e.key === "Tab") {
          if (focusableEls.length === 0) return;
          if (e.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
              e.preventDefault();
              lastFocusableEl.focus();
            }
          } else {
            if (document.activeElement === lastFocusableEl) {
              e.preventDefault();
              firstFocusableEl.focus();
            }
          }
        }
      }
      trapContainer.addEventListener("keydown", trapFocus);
      this._focusTrapCleanup = () => {
        trapContainer.removeEventListener("keydown", trapFocus);
        if (!firstFocusableEl) {
          trapContainer.removeAttribute("tabindex");
        }
      };
    }, 100);
  }

  //Close BaBUpsellModal and remove focus trap
  closeModal() {
    this.classList.remove("open");
    document.body.classList.remove("overflow-hidden");
    //   update aria-hidden
    this.setAttribute("aria-hidden", "true");
    window.recentlyClosedUpsellModal = true;

    // Hide the trigger button, show ATC button
    const upsellTrigger = document.querySelector(
      ".bob__summary #upsell-trigger"
    );
    const atcButton = document.querySelector(
      ".bob__summary .button--add-to-cart"
    );
    upsellTrigger.style.display = "none";
    atcButton.style.display = "inline-block";

    // Update z-index of aside.sidebar.bob__summary to 3
    const sidebar = document.querySelector("aside.sidebar.bob__summary");
    if (sidebar) {
      sidebar.style.zIndex = "9999999";
    }

    // Remove focus trap if set
    if (this._focusTrapCleanup) {
      this._focusTrapCleanup();
      this._focusTrapCleanup = null;
    }
    // Restore focus to previous element if provided
    if (
      this._focusTrapReturnTarget &&
      typeof this._focusTrapReturnTarget.focus === "function"
    ) {
      const prev = this._focusTrapReturnTarget;
      // If the element is disabled or not visible, try to find a parent
      const isVisible = (el) => {
        if (!el) return false;
        const style = window.getComputedStyle(el);
        return (
          style.display !== "none" &&
          style.visibility !== "hidden" &&
          el.offsetParent !== null
        );
      };
      let focusTarget = prev;
      while (
        (focusTarget.disabled || !isVisible(focusTarget)) &&
        focusTarget.parentElement
      ) {
        focusTarget = focusTarget.parentElement;
      }
      // If still not focusable, give up
      if (
        focusTarget &&
        typeof focusTarget.focus === "function" &&
        isVisible(focusTarget)
      ) {
        if (
          typeof focusTarget.tabIndex !== "undefined" &&
          focusTarget.tabIndex < 0
        ) {
          focusTarget.tabIndex = -1;
        }
        setTimeout(() => {
          focusTarget.focus();
          if (document.activeElement !== focusTarget) {
            focusTarget.focus();
          }
        }, 0);
      } else {
        return;
      }
      this._focusTrapReturnTarget = null;
    }
  }

  // Update selected product option and close modal
  updateSelectedProduct(button) {
    // Variant selector in BAB tool
    const variantSelector = document.querySelector(
      ".bob__summary variant-selects select"
    );

    // Selected variant's option value
    const optionValue = button.getAttribute("data-option-value");

    if (!variantSelector) {
      console.error("Variant selector not found");
      return;
    }

    // Find the <option> with the matching value
    const matchingOption = Array.from(variantSelector.options).find(
      (opt) => opt.value === optionValue
    );
    if (matchingOption) {
      variantSelector.value = optionValue;
      window.recentlyClosedUpsellModal = true;
      variantSelector.dispatchEvent(new Event("change"));
      // Also trigger onVariantChange on the closest variant-selects element
      // This helps it on mobile where the above doesn't guarantee the full update
      const variantSelects = variantSelector.closest("variant-selects");
      if (
        variantSelects &&
        typeof variantSelects.onVariantChange === "function"
      ) {
        variantSelects.onVariantChange();
      } else {
        console.warn("variant-selects element or onVariantChange() not found");
      }
    }

    this.closeModal();
    this.hideOptions();
  }

  //Get currently selected size, and hide anything lower than that
  hideOptions() {
    const variantSelector = document.querySelector(
      ".bob__summary variant-selects select"
    );
    let selectedSize = null;
    if (variantSelector) {
      // Get the selected <option> attribute with size info
      const selectedOption =
        variantSelector.options[variantSelector.selectedIndex];
      if (selectedOption) {
        selectedSize = selectedOption.getAttribute("data-option-size");
      }
    }

    this.productUpdate.forEach((button) => {
      const buttonValue = button.getAttribute("data-option-size");
      const buttonNum = Number(buttonValue);
      const selectedNum = Number(selectedSize);
      // Get the wrapper element for this button
      const wrapper = button.closest(".bab-upsell-modal--product-option");
      if (!wrapper) return;
      // Hide the wrapper if it matches the selected size, show if greater
      if (selectedSize && buttonNum <= selectedNum) {
        wrapper.style.display = "none";
      } else {
        wrapper.style.display = "flex";
      }
    });
  }

  //   Update whether default or subscription pricing should be showing, based on what the summary select option is
  updatePricing() {
    const planSelector = document.querySelector(
      ".bob__summary #sellingPlanOnOffToggle input"
    );
    // If not found, do nothing
    if (!planSelector) return;

    // Determine if subscription is selected
    const isSubscription = planSelector.checked;

    // Find all .price__subscription elements inside this modal
    const subscriptionPrices = this.querySelectorAll(".price__subscription");
    const savingMessage = this.querySelectorAll(".bab-upsell-modal--savings");

    // Show/hide saving message based on subscription selection
    // savingMessage.forEach((el) => {
    //   el.style.display = isSubscription ? "" : "none";
    // });
    subscriptionPrices.forEach((el) => {
      el.style.display = isSubscription ? "" : "none";
      el.classList.add(
        isSubscription ? "subscription-active-price" : "subscription-inactive"
      );
    });
  }
}
customElements.define("bab-upsell-modal", BaBUpsellModal);

document.addEventListener("DOMContentLoaded", function () {
  // Update global variable, this stops a user being shown the upsell again after already upselling
  window.recentlyClosedUpsellModal = false;
  // Listen for variant select changes, and update modal as needed to hide smaller sizes

  const variantSelector = document.querySelector(
    ".bob__summary variant-selects select"
  );
  if (variantSelector) {
    variantSelector.addEventListener("change", () => {
      const upsellModal = document.querySelector("bab-upsell-modal");
      if (upsellModal) {
        upsellModal.hideOptions();
      }

      // Update modal CTA to selected size
      const selectedOption =
        variantSelector.options[variantSelector.selectedIndex];
      const selectedSize = selectedOption
        ? selectedOption.getAttribute("data-option-size")
        : null;
      const selectedSizeEl = document.querySelector(
        ".bab-upsell-modal--selected-size"
      );
      if (selectedSizeEl && selectedSize) {
        selectedSizeEl.textContent = selectedSize;
      }
    });
  }

  // Update modal CTA to selected size
  const selectedOption = variantSelector.options[variantSelector.selectedIndex];
  const selectedSize = selectedOption
    ? selectedOption.getAttribute("data-option-size")
    : null;
  const selectedSizeEl = document.querySelector(
    ".bab-upsell-modal--selected-size"
  );
  if (selectedSizeEl && selectedSize) {
    selectedSizeEl.textContent = selectedSize;
  }

  // Listen for plan selector changes and trigger update pricing in the modal
  const planSelector = document.querySelector(
    ".bob__summary #sellingPlanOnOffToggle input"
  );
  if (planSelector) {
    planSelector.addEventListener("change", () => {
      const upsellModal = document.querySelector("bab-upsell-modal");
      if (upsellModal) {
        upsellModal.hideOptions();
        upsellModal.updatePricing();
      }
    });
  }

  // Trigger modal on upsellTrigger click
  // This is a "fake" add to cart button that opens the upsell modal
  const upsellTrigger = document.querySelector(".bob__summary #upsell-trigger");
  if (upsellTrigger) {
    upsellTrigger.addEventListener("click", (e) => {
      e.preventDefault();
      const upsellModal = document.querySelector("bab-upsell-modal");
      var currentFocus = document.activeElement;

      // Check subscription status
      const planSelector = document.querySelector(
        ".bob__summary #sellingPlanOnOffToggle input"
      );
      const isSubscription = planSelector && planSelector.checked;

      if (isSubscription) {
        // Close modal and trigger add to cart
        if (upsellModal) upsellModal.closeModal();

        // Trigger the add to cart functionality
        const atcButton = document.querySelector(
          ".bob__summary .button--add-to-cart"
        );
        if (atcButton) {
          atcButton.click();
        }
        return;
      }

      if (upsellModal) {
        let totalQuantity = 0;
        const boxSizeSelect = document.querySelector(
          '.bob__summary select.select__select[name^="options[Box Size]"]'
        );
        if (boxSizeSelect) {
          const selectedOption =
            boxSizeSelect.options[boxSizeSelect.selectedIndex];
          if (
            selectedOption &&
            selectedOption.hasAttribute("data-option-size")
          ) {
            totalQuantity = parseInt(
              selectedOption.getAttribute("data-option-size"),
              10
            );
          }
        }
        // hard set 0, as this button is only visible when spaces left are 0
        upsellModal.openModal(0, totalQuantity, currentFocus);
      }
    });
  }
});
